// src/app/state/reducers/auth.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { saveFcmToken } from '../actions/fcm.actions';


export interface FcmState {
  token: string | null;
  previousToken: string | null;
}

export const initialState: FcmState = {
  token: null,
  previousToken: null,
};

export const fcmReducer = createReducer<FcmState>(
  initialState,
  on(saveFcmToken, (state, { token }) => ({
    ...state,
    previousToken: state.token,
    token,
  })),
);